import React from "react";
import { TrainingCenterBundleItemVideoEngmtQuestionId } from "../../messages/ObjectIds";
import {
  EngagementChosenAnswer,
  TrainingCenterBundleItemVideoEngagementQuestion,
} from "../../system/AppState/AppStateTrainingCenter";
import { HashMap } from "../../utils/HashMap";
import { HashSet } from "../../utils/HashSet";
import { List } from "../../utils/List";
import { TrainingCenterLanguagePreference } from "./TrainingCenterLanguageLookup";
import TrainingCenterVideoEngagementQuestionWrapper from "./TrainingCenterVideoEngagementQuestionWrapper";

interface Props {
  playedSeconds: number;
  engagementQuestions: List<TrainingCenterBundleItemVideoEngagementQuestion>;
  chosenEngagementAnswers: HashMap<
    TrainingCenterBundleItemVideoEngmtQuestionId,
    EngagementChosenAnswer
  >;
  closedEngagementQuestions: HashSet<TrainingCenterBundleItemVideoEngmtQuestionId>;
  languagePreference: TrainingCenterLanguagePreference;
  onClickCloseAnswer: (engagementQuestion: TrainingCenterBundleItemVideoEngagementQuestion) => void;
  onClickAnswer: (
    question: TrainingCenterBundleItemVideoEngagementQuestion,
    answerValue: string,
    currentSecond: number
  ) => void;
  onBeforeTimeoutEnd: () => void;
}

const TrainingCenterVideoEngagementQuestions = ({
  playedSeconds,
  engagementQuestions,
  chosenEngagementAnswers,
  closedEngagementQuestions,
  languagePreference,
  onClickCloseAnswer,
  onClickAnswer,
  onBeforeTimeoutEnd,
}: Props) => {
  return (
    <div className="TrainingCenterVideoEngagementQuestions">
      {engagementQuestions.zipWithIndex().map(([engagementQuestion, index]) => (
        <TrainingCenterVideoEngagementQuestionWrapper
          key={index}
          currentSecond={playedSeconds}
          engagementQuestion={engagementQuestion}
          chosenEngagementAnswer={chosenEngagementAnswers.get(engagementQuestion.questionId)}
          isQuestionClosed={closedEngagementQuestions.has(engagementQuestion.questionId)}
          languagePreference={languagePreference}
          onClickClose={onClickCloseAnswer}
          onClickAnswer={onClickAnswer}
          onBeforeTimeoutEnd={onBeforeTimeoutEnd}
        />
      ))}
    </div>
  );
};

export default React.memo(TrainingCenterVideoEngagementQuestions);
